import * as React from "react";

const s = require("./SecondaryHeader.scss");

interface ISecondaryHeaderProps {
    title: string;
    onGoBack: () => any;
};

interface ISecondaryHeaderState {};

class SecondaryHeader extends React.Component<ISecondaryHeaderProps, ISecondaryHeaderState> {
    public render(): JSX.Element {
        return (
            <div className={s.header}>
                <div 
                    className={s.back}
                    onClick={event => this.props.onGoBack()}
                >
                    <i className="fa fa-angle-left" aria-hidden="true"></i> Voltar
                </div>
                <div className={s.title}>{this.props.title}</div>
            </div>
        );
    }
}

export default SecondaryHeader;



// WEBPACK FOOTER //
// ./src/components/Header/Secondary/index.tsx